import { render, staticRenderFns } from "./ScreenModal.vue?vue&type=template&id=4ef38a8c&scoped=true"
import script from "./ScreenModal.vue?vue&type=script&lang=js"
export * from "./ScreenModal.vue?vue&type=script&lang=js"
import style0 from "./ScreenModal.vue?vue&type=style&index=0&id=4ef38a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef38a8c",
  null
  
)

export default component.exports